import React from "react";
import "./PricingPlanCard.scss"
import tick from "../../assets/tick.svg"
import SecondaryButton from "../Button/SecondaryButton";
const PricingPlanCard = ({ data, selected, onClick }) => {
    return (
        <div className={`PricingPlanCard ${selected === data?.pricingHeader.toUpperCase() ? "selected" : ""}`}
            onClick={onClick}>
            <div className="PricingPlanCard-header">
                {data?.pricingHeader}
            </div>
            <div className="PricingPlanCard-subheader">
                {data?.pricingSubheader}
            </div>
            <div className="PricingPlanCard-priceCont">
                <div className="PricingPlanCard-priceCont-price">
                    {data?.priceValue}
                </div>
                <div className="PricingPlanCard-priceCont-text">
                    {data?.pricingSchemeText}
                </div>
            </div>
            <div className="PricingPlanCard-list">
                {data?.pricingPlan.map((plan, key) => {
                    return (
                        <div key={key} className="PricingPlanCard-list-item">
                            <img alt="" src={tick} />
                            {plan}
                        </div>
                    )
                })}
            </div>
            <div className="PricingPlanCard-btn-cont">
                <SecondaryButton buttonText={data?.buttonText} isPrimary={selected !== data?.pricingHeader.toUpperCase()} />
            </div>
        </div>
    )
}
export default PricingPlanCard